import React from "react"
import { useAdvancedSearchTOHMutation } from "../../core/api/toh-state-api"
import MultiSearch from "./MultiSearch"

export default function SearchBarTOH() {
    return <MultiSearch useSearchHook={useAdvancedSearchTOHMutation}/>
}
